import {
  Box,
  Modal,
  Table,
  TableHead,
  TableRow,
  TableBody,
  IconButton,
} from "@mui/material";
import { ModalBaseStyles, ModalHeader } from "../Common/styles/modal";
import { StyledTableCell } from "../Common/styles/table";
import { useState } from "react";
import { useAppSelector } from "../../Redux/hooks";
import { Edit, Visibility } from "@mui/icons-material";
import { permissions } from "../../utils/roles";
import SurveyPackagTranslationModal from "./SurveyPackageTranslations";

type Props = {
  showModal: boolean;
  closeModal: () => void;
  data: any;
  studyId: any;
};

const LanguageTranslationModal = ({
  showModal,
  closeModal,
  data,
  studyId,
}: Props) => {
  const [lang, setLang] = useState("");
  const [preview, setPreview] = useState(false);

  const isPermission = useAppSelector((state) =>
    state.study.studyPermissions.includes(permissions.studyDesigner)
  );
  const isStatus = useAppSelector((state) => state.study.status === "not_live");

  const languages = useAppSelector((state) => state.study.languages);
  const availableLanguages = languages?.filter(
    (lang) => lang.languageCode !== "en"
  );

  const handleClick = (action: boolean, lang: string) => {
    setPreview(action);
    setLang(lang);
  };

  const closeModalHandler = () => {
    setLang("");
    setPreview(false);
  };

  return (
    <Modal open={showModal} onClose={closeModal}>
      <Box sx={{ ...ModalBaseStyles, width: "60vw", minHeight: "20vh" }}>
        <ModalHeader
          title={"Language Translations for " + data?.name}
          onCloseClick={closeModal}
        />

        <Box
          sx={{
            maxHeight: "calc(100vh - 295px)",
            overflow: "auto",
            mb: 2,
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Languages</StyledTableCell>
                <StyledTableCell>Action</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {availableLanguages?.map((row: any) => (
                <TableRow key={row?.languageCode}>
                  <StyledTableCell>{row?.languageLabel}</StyledTableCell>
                  <StyledTableCell>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      {isPermission && isStatus && (
                        <IconButton
                          onClick={() => handleClick(false, row?.languageCode)}
                        >
                          <Edit sx={{ color: "text.secondary" }} />
                        </IconButton>
                      )}

                      <IconButton
                        onClick={() => handleClick(true, row?.languageCode)}
                      >
                        <Visibility sx={{ color: "text.secondary" }} />
                      </IconButton>
                    </Box>
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        {lang && (
          <SurveyPackagTranslationModal
            showModal={true}
            closeModal={closeModalHandler}
            data={data}
            lang={lang}
            studyId={studyId}
            preview={preview}
          />
        )}
      </Box>
    </Modal>
  );
};

export default LanguageTranslationModal;
